{
  "name": "@uppy/drag-drop",
  "description": "Droppable zone UI for Uppy. Drag and drop files into it to upload.",
  "version": "5.0.0",
  "license": "MIT",
  "main": "lib/index.js",
  "style": "dist/style.min.css",
  "type": "module",
  "sideEffects": [
    "*.css"
  ],
  "scripts": {
    "build": "tsc --build tsconfig.build.json",
    "build:css": "sass --load-path=../../ src/style.scss dist/style.css && postcss dist/style.css -u cssnano -o dist/style.min.css",
    "typecheck": "tsc --build"
  },
  "keywords": [
    "file uploader",
    "uppy",
    "uppy-plugin",
    "drag-drop",
    "drag",
    "drop",
    "dropzone",
    "upload"
  ],
  "homepage": "https://uppy.io",
  "bugs": {
    "url": "https://github.com/transloadit/uppy/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/transloadit/uppy.git"
  },
  "files": [
    "src",
    "lib",
    "dist",
    "CHANGELOG.md"
  ],
  "exports": {
    ".": "./lib/index.js",
    "./css/style.css": "./dist/style.css",
    "./css/style.min.css": "./dist/style.min.css",
    "./package.json": "./package.json"
  },
  "dependencies": {
    "@uppy/utils": "workspace:^",
    "preact": "^10.5.13"
  },
  "peerDependencies": {
    "@uppy/core": "workspace:^"
  },
  "devDependencies": {
    "cssnano": "^7.0.7",
    "postcss": "^8.5.6",
    "postcss-cli": "^11.0.1",
    "sass": "^1.89.2",
    "typescript": "^5.8.3"
  }
}
